module.exports = __webpack_public_path__ + "img/desktophomepagescale.6dec1378.png";